// FinancialSummary — Uplift Summary with %, investment range, net return
export function FinancialSummary({ valueHeadroom, valueHeadroomRange }) {
  const allStrats = [
    ...(valueHeadroom?.strategies || []),
    ...(valueHeadroom?.supportive_strategies || [])
  ];
  const withCosts = allStrats.filter(s => s.implementation_range);
  if (withCosts.length === 0) return null;

  const totalLow = withCosts.reduce((sum, s) => sum + (s.implementation_range?.lower || 0), 0);
  const totalHigh = withCosts.reduce((sum, s) => sum + (s.implementation_range?.upper || 0), 0);
  const vr = valueHeadroomRange;
  const netHigh = vr ? Math.max(0, vr.max - totalLow) : 0;

  // Calculate total % uplift from strategies
  const totalPctLow = allStrats.reduce((sum, s) => sum + (s.percentage_range?.lower || 0), 0);
  const totalPctHigh = allStrats.reduce((sum, s) => sum + (s.percentage_range?.upper || 0), 0);

  return (
    <div className="bg-white/[0.03] border border-white/5 rounded-xl p-3.5 space-y-2" data-testid="financial-summary">
      <p className="text-[10px] text-white/30 uppercase tracking-wider">Uplift Summary</p>
      <div className="grid grid-cols-3 gap-2">
        <div className="text-center">
          <p className="text-[9px] text-white/30 mb-0.5">Potential Uplift</p>
          <p className="text-sm font-bold text-cipher-green/80">
            {totalPctLow}–{totalPctHigh}%
          </p>
        </div>
        <div className="text-center">
          <p className="text-[9px] text-white/30 mb-0.5">Investment</p>
          <p className="text-sm font-bold text-white/60">
            £{Math.round(totalLow / 1000)}k–{Math.round(totalHigh / 1000)}k
          </p>
        </div>
        <div className="text-center">
          <p className="text-[9px] text-white/30 mb-0.5">Net Return</p>
          <p className="text-sm font-bold text-cipher-green">
            £{Math.round(netHigh / 1000)}k
          </p>
        </div>
      </div>
    </div>
  );
}
